import { render, staticRenderFns } from "./resetPhone.vue?vue&type=template&id=ac1daa7e&scoped=true"
import script from "./resetPhone.vue?vue&type=script&lang=js"
export * from "./resetPhone.vue?vue&type=script&lang=js"
import style0 from "./resetPhone.vue?vue&type=style&index=0&id=ac1daa7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1daa7e",
  null
  
)

export default component.exports